import Notification from "./Notification";
import {Communication} from "../../../util/types";
import {patchSelfcareCommunication} from "../../../util/request";
import {useCustomer} from "../../../layouts/SelfcareLayout";
import dayjs from "dayjs";

interface NotificationListProps {
    requests: Communication[];
    onUpdate?: () => void;
}

export default function NotificationList({requests, onUpdate}: NotificationListProps) {
    const {customer} = useCustomer();

    const handleMarkAllAsRead = () => {
        requests.forEach(request => patchSelfcareCommunication(customer.customer_id, request.request_id, {read: true}))
        onUpdate && onUpdate()
    }

    const hasUnreadRequests: boolean = requests.some((request: Communication) => request.read_dtm === null)

    const sortedRequests = requests.sort((a, b) => {
        return dayjs(a.sent_dtm).isAfter(b.sent_dtm) ? -1 : 1
    })

    return <>
        {hasUnreadRequests && <button className="mark-all-as-read" onClick={handleMarkAllAsRead}>Markér alle som læst</button>}
        <ul className="selfcare-delivery-flow-notification-list">
            {sortedRequests.map((request) =>
                <Notification
                    key={request.request_id}
                    request={request}
                    onUpdate={onUpdate}
                />
            )}
        </ul>
    </>
}
